export const APP_ID = '1189100693'
export const MTXC_SITE = 'https://mtxc.eu'
export const MTXC_CN_SITE = 'https://mtxc.com.cn'
export const MTXC_FAQ_SITE = 'https://faq.mtxc.eu'
export const DEFAULT_LOCALE = 'en'
export const RUSSIAN_LOCALE = 'ru'
export const JAPAN_LOCALE = 'jp'
export const CHINA_REGION = 'cn'
export const FREE_CHAT = 'FREE CHAT'
export const PAY_AS_YOU_GO_ID = '201507011621367309'
export const FREE_CHAT_ID = '201603292018576667'
export const ADDRESS_SEPARATOR = ', '
export const envs = {
  DEVELOPMENT: 'development',
  STAGING: 'staging',
  PRODUCTION: 'production',
}
export const ACCEPTED_STATUS = 'accepted'
export const ACCOUNT_SIMCARDS_LIMIT = 10

export const CANADA_CODE = 'CA'
export const CHINA_CODE = 'CN'
export const RUSSIA_CODE = 'RU'

export const NEW_SIM_KEY = 'newSim'

// export const validLatinChars = /([^\x20-\x7E]+)/g
export const validLatinChars = '[^\\p{Latin}\\p{Common}]'



// WEBPACK FOOTER //
// ./app/javascript/components/dashboard/constants/index.js